import { sellerShopRoutes } from './apiRoutes';
import { axiosAuthInstance } from './auth';

export const seller_Shop = (queryParams) => axiosAuthInstance.get(sellerShopRoutes.sellershop, { params: queryParams });
